import { useMemo, useState, useEffect, useRef } from "react";
import FilterIcon from "../../IconsCode/FilterIcon";

function FilterOrganization({ users = [], onSelect }) {
    const [searchTerm, setSearchTerm] = useState("");
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState("همه");
    const containerRef = useRef(null); // ✅ برای شناسایی کلیک بیرون

    const orgList = useMemo(() => {
        const unique = new Set();
        users.forEach((u) => {
            if (u.name && !unique.has(u.name)) unique.add(u.name);
        });
        return ["همه", ...Array.from(unique)];
    }, [users]);

    const filteredList = useMemo(() => {
        return orgList.filter((org) =>
            org.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [searchTerm, orgList]);

    const handleSelect = (org) => {
        setSelected(org);
        setOpen(false);
        setSearchTerm("");
        if (onSelect) onSelect(org);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open]);

    return (
        <div
            ref={containerRef} // ✅ اضافه‌شده
            className="relative flex flex-row-reverse items-center ml-2"
        >
            <div
                onClick={() => setOpen(!open)}
                className="flex flex-row-reverse items-center justify-between bg-primary-100 border border-slate-300 border-r-0 rounded-l-lg p-2 cursor-pointer w-44 h-11"
            >
                <span className="text-sm text-right truncate">{selected}</span>
                <FilterIcon />
            </div>

            {open && (
                <div className="absolute top-10 right-0 bg-white border border-gray-300 rounded-b-lg shadow-lg w-44 z-50">
                    <input
                        type="text"
                        placeholder=" ... جستجو"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full p-2 border-b border-gray-200 text-sm text-right outline-none"
                    />

                    <ul className="max-h-56 overflow-y-auto">
                        {filteredList.map((org, index) => (
                            <li
                                key={index}
                                onClick={() => handleSelect(org)}
                                className={`px-3 py-2 text-sm text-right cursor-pointer hover:bg-primary-100 ${org === selected ? "bg-primary-200 font-semibold" : ""
                                    }`}
                            >
                                {org}
                            </li>
                        ))}
                        {filteredList.length === 0 && (
                            <li className="p-2 text-gray-400 text-sm text-center">
                                موردی یافت نشد
                            </li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
}
export default FilterOrganization;